import {client} from '../helpers/api';

export async function postCreateIosPayment({
  receipt,
  kidId,
  packageId,
  selectedTimeTable,
  subjectNames,
  renewData,
  monthNumber,
}) {
  const formBody = {
    kid_id: kidId,
    package_id: packageId,
    subject_names: subjectNames,
    month_number: monthNumber,
    tx_receipt: receipt,
  };
  if (selectedTimeTable) {
    try {
      const scheduleData = JSON.stringify(
        convertTimeTableData(selectedTimeTable),
      );
      formBody.schedule_data = scheduleData;
    } catch (error) {
      console.log(
        '🚀 ~ file: postCreateIosPayment.js ~ line 56 ~ error',
        error,
      );
    }
  }
  if (renewData) {
    formBody.price_per_subject = renewData.pricePerSubject;
    formBody.no_of_subject = renewData.noOfSubject;
    formBody.total_price = renewData.totalPrice;
  }
  // console.log('body', body);

  const response = await client.post('/api/ios-payment-process', formBody);

  return response.data || {};
}

function convertTimeTableData(selectedTimeTable) {
  return selectedTimeTable.reduce((acc, {scheduleId, weekDay}) => {
    const dayObject = acc.find(({week_day}) => week_day === weekDay);
    if (dayObject) {
      dayObject.schedules.push(scheduleId);
      const newRes = acc.map((item) =>
        item.week_day === weekDay ? dayObject : item,
      );
      return newRes;
    } else {
      const newDayObject = {
        week_day: weekDay,
        schedules: [scheduleId],
      };
      const newRes = [...acc, newDayObject];
      return newRes;
    }
  }, []);
}
